module.exports = __webpack_public_path__ + "img/u6.0c470764.svg";